import React from "react";
import { Box, Typography } from "@mui/material";
import Button from "./elements/Button";
import { Link } from "react-router-dom";


export const ResetPassword = () => {
      return(
         <Box margin="10px">
            <section className="mt-8">
               <Box className="container mt-10">
                  <Box className="flex flex-wrap -mx-4">
                     <Box className="w-full px-4">
                        <Box className="max-w-[525px] bg-transparent mx-auto rounded-lg relative overflow-hidden
                           py-8
                           px-10
                           sm:px-12
                           md:px-[60px]
                           "
                           >
                           <Box className="mb-5 md:mb-8 text-center">
                              <img 
                                 src={require("../assets/images/logo.png")} 
                                 alt="TripHub Logo"
                                 className="w-55 h-20 mx-auto"
                              />
                           </Box>
                           <form >
                              <Typography 
                                 variant="h5"
                                 sx={{ fontWeight:"500", marginTop: "-5%"}}
                                 gutterBottom
                              >
                                 Reset password
                              </Typography>
                              <Box className="mt-4 mb-4">
                                 <label>
                                    Verification Code <br />
                                    <input
                                       name="verifycode"
                                       type="text"
                                       placeholder="Verification code"
                                       className="
                                       w-full
                                       rounded-md
                                       border
                                       border-[#E9EDF4]
                                       py-3
                                       px-5
                                       bg-[#FCFDFE]
                                       text-black
                                       placeholder-[#ACB6BE]
                                       outline-none
                                       focus-visible:shadow-none
                                       focus:border-pry
                                       "
                                    />
                                 </label>
                              </Box>
                              <Box className="mt-4 mb-4">
                                 <label htmlFor="password">
                                    New Password <br />
                                    <input
                                       name="password"
                                       type="password"
                                       placeholder="Password"
                                       className="
                                       w-full
                                       rounded-md
                                       border
                                       border-[#E9EDF4]
                                       py-3
                                       px-5
                                       bg-[#FCFDFE]
                                       text-black
                                       placeholder-[#ACB6BE]
                                       outline-none
                                       focus-visible:shadow-none
                                       focus:border-pry
                                       "
                                    />
                                 </label>
                              </Box>
                              <Box className="mb-3">
                                 <label>
                                    Confirm Password <br />
                                    <input
                                       name="password"
                                       type="password"
                                       placeholder="Password"
                                       className="
                                       w-full
                                       rounded-md
                                       border
                                       border-[#E9EDF4]
                                       py-3
                                       px-5
                                       bg-[#FCFDFE]
                                       text-black
                                       placeholder-[#ACB6BE]
                                       outline-none
                                       focus-visible:shadow-none
                                       focus:border-pry"
                                    />
                                 </label>
                              </Box>
                             
                              <Box className="mt-[-6%] mb-5">
                                 <Button size="large" className="px-12">Change Password</Button>
                                 <Link to="/">
                                    <Typography 
                                        variant="h6" 
                                        paragraph
                                        sx={{
                                            fontWeight: "400",
                                            textAlign: "center",
                                            marginTop: "10px",
                                            marginBottom: "50px",
                                            fontSize: "14px"
                                        }}
                                        className="text-gray-500"
                                    >
                                        Back to Homepage
                                    </Typography>
                                </Link>
                              </Box>
                           </form>
                           

                        </Box>
                     </Box>
                  </Box>
               </Box>
            </section>
         </Box>
      )
}